import type { ComponentType } from "react";
import { AudioRenderer, AudioSlidesRenderer, VideoRenderer } from "./MediaRenderers";
import {
  DownloadRenderer,
  EmbedRenderer,
  GalleryRenderer,
  ImageRenderer,
  LinkRenderer,
  ResourcePackRenderer,
  SlidesRenderer,
  TextRenderer,
} from "./DocumentRenderers";
import { PracticalActivityRenderer, ReflectionRenderer } from "./ResponseRenderers";
import type { RendererProps } from "./types";

export const CONTENT_RENDERERS: Record<string, ComponentType<RendererProps>> = {
  video: VideoRenderer,
  audio: AudioRenderer,
  audio_slides: AudioSlidesRenderer,
  text: TextRenderer,
  image: ImageRenderer,
  gallery: GalleryRenderer,
  slides: SlidesRenderer,
  downloadable: DownloadRenderer,
  resource_pack: ResourcePackRenderer,
  external_link: LinkRenderer,
  embed: EmbedRenderer,
  practical_activity: PracticalActivityRenderer,
  reflection: ReflectionRenderer,
};

export type { RendererProps } from "./types";
